import { getAllInventoryProducts, getLowInventoryProducts, getOutOfStockInventories } from "../../actions/productInventory";
import { ProductInventoryTabs } from "./productinventory.constants";

export function fetchTabData(state) {
  const { currentTab } = state;
  switch (currentTab) {
    case ProductInventoryTabs.allProducts: {
      const resultData = {
        data: null,
        func: getAllInventoryProducts
      }
      if (state.allProducts.data) {
        resultData['data'] = true;
        return resultData;
      }
      return resultData;
    }

    case ProductInventoryTabs.lowInventory: {
      const resultData = {
        data: null,
        func: getLowInventoryProducts
      }
      if (state.lowInventory.data) {
        resultData['data'] = true;
        return resultData;
      }
      return resultData;
    }

    case ProductInventoryTabs.outofStock: {
      const resultData = {
        data: null,
        func: getOutOfStockInventories
      }
      if (state.outOfStock.data) {
        resultData['data'] = true;
        return resultData;
      }
      return resultData;
    }

    default:
      return {
        data: null,
        func: getAllInventoryProducts
      };
  }
}